<template>
  <div
    ref="descriptionContent"
    class="flex w-92 flex-col gap-2 z-100 rounded-sm border border-blue-200 bg-white p-2 shadow-lg"
    data-cy="stip-description-container"
  >
    <lf-textarea
      :placeholder="$t('STIPS.ADD_DESCRIPTION')"
      rows="4"
      :name="`stip-description-${stip.id}`"
      noresize
      :character-limit="TEXT_CHARACTER_LIMIT_MEDIUM"
      :value="description"
      data-cy="stip-description-text-area"
      @key-released="description = $event"
    />
    <modal-buttons
      class="grow justify-end px-0"
      :on-cancel="handleClose"
      :on-save="handleSave"
      @click.prevent
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

import { TEXT_CHARACTER_LIMIT_MEDIUM } from "@/helpers/constants";

import ModalButtons from "@/components/ui/ModalButtons.vue";
import LfTextarea from "@/components/ui/inputs/LfTextarea.vue";

import type { FieldStip } from "@/models/stips";

const props = defineProps<{
  stip: FieldStip;
}>();

const emit = defineEmits<{
  close: [];
  "description:saved": [string];
}>();

const description = ref(props.stip.description ?? "");

const handleSave = () => {
  emit("description:saved", description.value);
  emit("close");
};

const handleClose = () => {
  emit("close");
};
</script>
